<template>
  <div>
    <v-card class="mb-12" color="lighten-1">
      <ValidationObserver ref="obs">
        <v-form ref="form" lazy-validation>
          <ValidationProvider name="Name" rules="required|max:30">
            <v-text-field
              slot-scope="{
                errors,
                valid
              }"
              :error-messages="errors"
              :success="valid"
              v-validate="'required'"
              v-model="invoice.to.name"
              :label="$t('app.client_name')"
              required
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="Address" rules="required">
            <v-textarea
              slot-scope="{
                errors,
                valid
              }"
              :error-messages="errors"
              :success="valid"
              v-model="invoice.to.address"
              :label="$t('app.address')"
            ></v-textarea>
          </ValidationProvider>
          <v-textarea v-model="invoice.to.details" :label="$t('app.details')"></v-textarea>
          <ValidationProvider name="Email" rules="required|max:40|email">
            <v-text-field
              slot-scope="{
                errors,
                valid
              }"
              :error-messages="errors"
              :success="valid"
              v-model="invoice.to.email"
              label="E-mail"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-form>
      </ValidationObserver>
    </v-card>

    <v-btn color="primary" @click="nextStepper">{{$t('app.continue')}}</v-btn>

    <v-btn @click="prevStep" text>{{$t('app.back')}}</v-btn>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "StepTwo",
  computed: {
    ...mapState(["invoice", "e1"])
  },
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["nextStep", "prevStep"]),
    async nextStepper() {
      const result = await this.$refs.obs.validate();
      if (result) {
        this.nextStep();
      }
    }
  }
};
</script>

<style scoped>
</style>